import axios from '@/axios'

export const register = (...args) => axios.post('/v1/user/register', ...args)

export const login = (...args) => axios.post('/v1/user/login', ...args)

export const getUserinfo = (...args) => axios.get('/v1/user/userinfo', ...args)

export const userLogout = (...args) => axios.get('/v1/user/logout', ...args)
